<h2>
    {{'HELLO' | translate:(gs.name$|async)}}
</h2>


// WEBPACK FOOTER //
// ./src/app/components/hello/hello.component.html